/* Batch 32 · currency over 10 characters — a currency typed as its name gets its ISO code suggested beside the rule
 * ("Saudi Riyal" → SAR). Same names as the server's engagement_locale.CURRENCY_NAME_TO_ISO, then the browser's own currency
 * names (EN + AR) of the listed ISO codes. "" when nothing matches. */
import { CURRENCY_CODES, currencyName } from "@/lib/engagementLocale";

const NAMES = {
  "saudi riyal": "SAR", "saudi arabian riyal": "SAR", "ريال سعودي": "SAR", "uae dirham": "AED", "emirati dirham": "AED",
  "united arab emirates dirham": "AED", "درهم إماراتي": "AED", "qatari riyal": "QAR", "ريال قطري": "QAR",
  "omani rial": "OMR", "ريال عماني": "OMR", "kuwaiti dinar": "KWD", "دينار كويتي": "KWD", "bahraini dinar": "BHD",
  "دينار بحريني": "BHD", "us dollar": "USD", "united states dollar": "USD", "دولار أمريكي": "USD", "euro": "EUR",
  "يورو": "EUR", "pound sterling": "GBP", "british pound": "GBP", "جنيه إسترليني": "GBP", "egyptian pound": "EGP",
  "جنيه مصري": "EGP", "jordanian dinar": "JOD", "دينار أردني": "JOD", "indian rupee": "INR", "pakistani rupee": "PKR",
};

const norm = (s) => String(s || "").replace(/-/g, " ").split(/\s+/).filter(Boolean).join(" ").toLowerCase();

export function suggestCurrencyCode(text) {
  let k = norm(text);
  if (!k) return "";
  if (k.endsWith("s") && NAMES[k.slice(0, -1)]) k = k.slice(0, -1);
  if (NAMES[k]) return NAMES[k];
  for (const code of CURRENCY_CODES) {
    for (const lang of ["en", "ar"]) {
      const n = norm(currencyName(code, lang));
      if (n && n !== code.toLowerCase() && (n === k || `${n}s` === k)) return code;
    }
  }
  return "";
}
